<section>
    <h2>{{ (data | async)?.Titulo }}</h2>
    <section *ngFor="let linea of (data | async).Cuerpo">
        <p>{{linea.Cuerpo}}</p>
    </section>
</section>